import React, { PropTypes } from 'react';
import { trUri } from '../utils';

const prevent = (e, callback) => {
  e.preventDefault();
  e.stopPropagation();
  callback();
};

const BgSlide = ({ item, goNext, showSection, locked, lang }) => (
  <div
    className="scroll-part"
    onClick={(e) => prevent(e, (trUri(item, lang) === '/') ? goNext : showSection)}
    style={{ backgroundImage: `url(${item.get('background')})` }}
  >
    <div className="imgbg" />
    {locked || <div>
      <span className="mousedownicon appearicon" onClick={(e) => prevent(e, goNext)} />
    </div>}
  </div>
);

BgSlide.propTypes = {
  item: PropTypes.object.isRequired,
  locked: PropTypes.bool.isRequired,
  goNext: PropTypes.func.isRequired,
  showSection: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
};

export default BgSlide;



// WEBPACK FOOTER //
// ./common/components/BgSlide.js